export function BootScreen({ label }: { label?: string }) {
  return (
    <div className="boot-screen">
      <span className="boot-mark" />
      {label ? <span>{label}</span> : null}
    </div>
  );
}
